// extracted by mini-css-extract-plugin
module.exports = {"figcaption":"figcaption_figcaption__1gnL1"};